/**
 * Escape a string for safe interpolation into an HTML string.
 *
 * Needed wherever untrusted or model-authored text is assembled into markup by
 * hand rather than rendered by React — the print-export document (WF-101) and
 * the podcast comprehension-questions clipboard payload (WF-75).
 */
export const escapeHtml = (value: string): string =>
	value.replace(
		/[&<>"']/g,
		(char) =>
			({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[char] as string
	);
